import { Grid } from "@material-ui/core";
import * as React from "react";
import Droit from "./CreationDroit/Droit";
import Module from "./CreationDroit/Module";
import SousModule from "./CreationDroit/SousModuleDroit";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../store";
import {
  setFilterDroits,
  setDroits,
  IDroit,
} from "./CreationDroit/Droit/droitSlice";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import VisualiserDroit from "./VisualiserDroit";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { IModuleDroit, setModuleDroits } from "./CreationDroit/Module/moduleDroitSlice";
import Utilisateur from "./Utilisateur";
import { ISousModuleDroit, setSousModuleDroits } from "./CreationDroit/SousModuleDroit/sousModuleDroitSlice";
import LoadingButton from "@mui/lab/LoadingButton";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Box } from "@mui/material";
import { errorNotify, successNotify } from "../../util/functions";
import PrintIcon from '@mui/icons-material/Print';
import { PrintEtat } from "./Etat/print";




export const dataOnglet = [
  { id: 0, libelle: "Utilisateur" },
  { id: 1, libelle: "Création de droit" },
  { id: 2, libelle: "Visualisation des droits" }
]





const AppGestionInterne = () => {
  //redux
  const dispatch = useDispatch();
  const { droits } = useSelector((state: IReduxState) => state.droits);



  //hooks
  const [creer, setCreer] = React.useState(false);
  const [search, setSearch] = React.useState("");
  const [active, setActive] = React.useState(0)
  const theme = useTheme();
  const modeEcran = useMediaQuery(theme.breakpoints.down("lg"));
  const [generateLoading, setGenerateLoading] = React.useState(false)


  const filterDroits = () => {
    if (search.length === 0) {
      dispatch(setFilterDroits([...droits]));
    } else {
      const result: any = droits.filter((item, index) => {
        const value: any = `${item.libDroit} ${item.descriptionDroit} ${item.idDroit}`;
        return value.toLowerCase().includes(search.toLowerCase());
      });
      dispatch(setFilterDroits(result));
    }
  };

  React.useEffect(() => {
    filterDroits();
  }, [search]);


  //les modules
  const getModulesDroitData = async () => {
    try {
      const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, "/tablesystem/listemoduledroit");
      if (res.status === 1) {
        const x = res.data.map((m: IModuleDroit) => {
          return { ...m, id: m.idModuleDroit, libelle: m.libModuleDroit };
        });
        dispatch(setModuleDroits(x));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:62 ~ getModulesDroitData ~ error:", error)
    }
  };

  //les sous modules
  const getSousModulesDroitData = async () => {
    try {
      const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, "/tablesystem/listesousmoduledroit");
      if (res.status === 1) {
        const x = res.data.map((m: ISousModuleDroit) => {
          return { ...m, id: m.idSousModuleDroit, libelle: m.libSousModuleDroit };
        });
        dispatch(setSousModuleDroits(x));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:62 ~ getModulesDroitData ~ error:", error)
    }
  };


  //les droits
  const getDroitsData = async () => {
    try {
      const res: any = await apiClient.get(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/listedroit"
      );
      if (res.status === 1) {
        const x = res.data.map((f: IDroit) => {
          return {
            ...f,
            id: f.idDroit,
            libelle: f.libDroit,
          };
        });
        dispatch(setDroits(x));
        dispatch(setFilterDroits(x));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:92 ~ getDroitsData ~ error:", error)
    }
  };


  React.useEffect(() => {
    getModulesDroitData();
    getDroitsData();
    getSousModulesDroitData();
  }, []);



  const generateJsonFile = async () => {
    try {
      setGenerateLoading(true)
      const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/creerdroitutilisateurjson", {});
      if (res.status === 1) successNotify("Fichier JSON généré avec succès.");
    } catch (error: any) {
      console.log("🚀 ~ file: index.tsx:142 ~ generateJsonFile ~ error:", error)
      errorNotify("Erreur lors de la création du fichier json.");
    } finally {
      setGenerateLoading(false)
    }
  }


  const renderContent = () => {
    if (active === 0) {
      return (<Utilisateur />)
    } else if (active === 1) {
      return (<Grid
        container
        spacing={3}
        style={{
          height: "55vh",
          overflow: "none"
        }}
      >
        <Grid item xs={12} md={4}>
          <Module />
        </Grid>
        <Grid item xs={12} md={4}>
          <SousModule />
        </Grid>
        <Grid item xs={12} md={4}>
          <Droit />
        </Grid>
      </Grid>)
    }
    else if (active === 2) {
      return (
        <Grid
          container
          spacing={3}
          style={{
            height: "70vh",
            overflow: "none"
          }}
        >
          <Grid item xs={12} md={10}>
            <TextField
              style={{ marginTop: modeEcran ? 15 : 0 }}
              size="small"
              fullWidth
              label="Rechercher..."
              onChange={(e) => setSearch(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Box style={{ display: "flex", justifyContent: "flex-end" }} >
              <PrintEtat />
            </Box>
          </Grid>
          <Grid item xs={12} md={12}><VisualiserDroit /></Grid>
        </Grid>
      )
    }
  }



  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="center"
        spacing={2}
        style={{
          background: "aliceblue",
          marginBottom: 10,
          height: "9vh",
          padding: 10,
        }}
      >
        <Grid
          item
          xs={12}
          md={12}
          style={{
            overflowX: "auto", /* Ajouter une barre de défilement horizontale si nécessaire */
            whiteSpace: "nowrap", /* Empêcher les éléments de passer à la ligne */
          }}
        >
          {dataOnglet.map((item: any, index) => (
            <Button
              key={index}
              // startIcon={<AddIcon />}
              variant={active === item.id ? "contained" : "text"}
              onClick={() => setActive(item.id)}
              style={{ marginRight: 5 }}
            >
              {item.libelle}
            </Button>
          ))}
        </Grid>
      </Grid>

      {renderContent()}
    </div>
  );
};

export default AppGestionInterne;
